import { ValidationResult, fluentValidator } from "sprint-common-web";

export const validateDuration = (durationInput: string): ValidationResult => {
    const durationRegex = /^(?:\d+|[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
    return fluentValidator<string>()
        .when((duration) => !!duration && !durationRegex.test(duration))
        .addError("Duration should be in hh:mm:ss format")
        .validate(durationInput);
};
